import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=76b64438&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=ts&"
export * from "./BaseButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=76b64438&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b64438",
  null
  
)

export default component.exports